import React, { useEffect } from 'react';
import V2Nav from './V2Nav';
import V2Footer from './V2Footer';

// Fixed positions so the starfield is stable across renders (no randomness,
// which would break prerender hydration).
const TWINKLES = [
  { top: '12%', left: '8%', variant: '', delay: '0s' },
  { top: '22%', left: '72%', variant: '--mint', delay: '1.2s' },
  { top: '38%', left: '31%', variant: '', delay: '2.1s' },
  { top: '55%', left: '88%', variant: '--nebula', delay: '0.6s' },
  { top: '68%', left: '15%', variant: '', delay: '2.8s' },
  { top: '82%', left: '58%', variant: '--mint', delay: '1.7s' },
  { top: '8%', left: '45%', variant: '--nebula', delay: '3.4s' },
  { top: '90%', left: '80%', variant: '', delay: '0.9s' },
];

const V2Layout = ({ children }) => {
  useEffect(() => {
    document.body.classList.add('v2-active');
    return () => document.body.classList.remove('v2-active');
  }, []);

  return (
    <div className="v2-root">
      <div className="v2-starfield" aria-hidden="true">
        {TWINKLES.map((t, i) => (
          <span
            key={i}
            className={`v2-starfield__twinkle ${t.variant ? `v2-starfield__twinkle${t.variant}` : ''}`}
            style={{ top: t.top, left: t.left, animationDelay: t.delay }}
          />
        ))}
      </div>
      <V2Nav />
      <main>{children}</main>
      <V2Footer />
    </div>
  );
};

export default V2Layout;
